import React, { useState } from "react";
import { ChannelContext } from "../contexts";
import "../assets/styles/menu.sass";
import Utility from "../Utility";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
const Menu = ({ content }) => {
  const [menuActive, setMenuActive] = useState(false);
  const menu = (
    <ChannelContext.Consumer>
      {(currentChannel) => {
        const channel = Utility.getChannel(content, currentChannel);
        const channelColor =
          channel && channel.colors && channel.colors.main
            ? channel.colors.main
            : null;
        const linksList = channel && channel.mainMenu ? channel.mainMenu : [];
        if (!linksList || linksList.length === 0) return null;
        return (
          <>
            {menuActive ? null : (
              <div className="ur-mini-menu-hamburger">
                <GiHamburgerMenu
                  size={"2rem"}
                  color={channelColor}
                  onClick={() => {
                    setMenuActive(!menuActive);
                  }}
                />
              </div>
            )}
            {menuActive ? (
              <div className="ur-mini-menu-close">
                <IoMdClose
                  size={"2rem"}
                  color={"white"}
                  onClick={() => {
                    setMenuActive(false);
                  }}
                />
              </div>
            ) : null}
            <div
              className={
                "ur-mini-menu" + (menuActive ? " ur-mini-mobile-active" : "")
              }
              style={
                channelColor ? { backgroundColor: channel.colors.main } : null
              }
            >
              {linksList.map(
                (
                  link,
                  index // Wrap map() call in curly braces
                ) => (
                  <Link
                    key={index}
                    to={link.url}
                    onClick={() => {
                      setMenuActive(false);
                    }}
                    className="ur-mini-menu-link"
                  >
                    {link.title}
                  </Link>
                )
              )}
            </div>
          </>
        );
      }}
    </ChannelContext.Consumer>
  );
  return <>{menu}</>;
};
export default Menu;
